import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { catchError, Observable, of } from 'rxjs';
import { ApiOperation } from '../../../../definitions/apis/api-operation';
import { ApiOperationsService } from '../services/api-operations.service';

export const apiOperationResolver: ResolveFn<ApiOperation> = (
	route: ActivatedRouteSnapshot
): Observable<ApiOperation> => {
	const dataSvc = inject(ApiOperationsService);
	const operationId = route.paramMap.get('operationId');

	return operationId
		? dataSvc.find(operationId).pipe(catchError(() => of(null)))
		: of(null);
};
